const FRACTA_WISHLIST = {
  APP_URL: "/apps/wishlist",
  list: async (customerId) => {
    return await fetch(`${FRACTA_WISHLIST.APP_URL}/${customerId}`).then((res) =>
      res.json()
    );
  },
  get: async (customerId, resourceId, type) => {
    return await fetch(
      `${FRACTA_WISHLIST.APP_URL}/${customerId}/${type}/${resourceId}`
    ).then((res) => res.json());
  },
  post: async (customerId, resourceId, type, payload) => {
    const body = JSON.stringify(payload);
    return await fetch(
      `${FRACTA_WISHLIST.APP_URL}/${customerId}/${type}/${resourceId}`,
      { method: "POST", body: body }
    ).then((res) => res.json());
  },
  delete: async (customerId, resourceId, type) => {
    return await fetch(
      `${FRACTA_WISHLIST.APP_URL}/${customerId}/${type}/${resourceId}`,
      { method: "DELETE" }
    ).then((res) => res.json());
  },
};

const FRACTA_WISHLIST_FRONTEND = {
  WISHLIST_TYPES: ["articles", "products"],
  getHandleURL: (item) => {
    switch (item.type) {
      case "articles":
        return `/blogs/${item.blog_title}/${item.shopify_object.handle}`;
      case "products":
        return `/products/${item.shopify_object.handle}`;
      default:
        return `${item.shopify_object.handle}`;
    }
  },
  getVal: (attr, obj) => {
    if (obj === null || obj === undefined) return null;
    const keys = attr.split(".");
    const key = keys.shift();
    let value;
    const regexp = /([a-z]+)\[([\d]+)\]/i;
    const matched = key.match(regexp);
    if (matched && matched.length > 0) {
      const attrName = matched[1];
      const index = matched[2];
      value = obj[attrName][index];
    } else {
      value = obj ? obj[key] : null;
    }
    return keys.length > 0
      ? FRACTA_WISHLIST_FRONTEND.getVal(keys.join("."), value)
      : value;
  },
  displayWishedItemsNotFoundMessage: () => {
    //Display a message if the wished item is not found;
    FRACTA_WISHLIST_FRONTEND.WISHLIST_TYPES.forEach((type) => {
      const toggle = $(`#fracta-wishlist-grid-${type}`).is(":not(:has(*))");
      $(`#fracta-wishlist-grid-${type}-message-area`).toggle(toggle);
    });
  },

  wishHandler: async (wishlistContainers, customerId) => {
    wishlistContainers.each(async function () {
      const wishlist = $(this);
      const wishlistType = wishlist.attr("wishlist-type");
      // console.log(`${wishlistType} Page`);

      if (!FRACTA_WISHLIST_FRONTEND.WISHLIST_TYPES.includes(wishlistType))
        return;

      const resourceId = wishlist.attr("resource-id");
      const res = await FRACTA_WISHLIST.get(
        customerId,
        resourceId,
        wishlistType
      );
      const initWished = res.Count > 0;

      wishlist.data("wished", initWished).toggleClass("wished", initWished);

      // ボタンの初期化完了時にクラスを追加する
      wishlist.addClass("loaded");

      wishlist.bind("click", async () => {
        const wished = wishlist.data("wished");
        if (wished) {
          // REMOVE FROM LIST
          wishlist.data("wished", false).removeClass("wished");
          const res = await FRACTA_WISHLIST.delete(
            customerId,
            resourceId,
            wishlistType
          );
          // console.log("wished removed", res);

          // GAに送信
          if (wishlistType == "articles") {
            // GAイベント
            if (typeof gtag !== "undefined") {
              gtag("event", "_" + resourceId, {
                event_category: "remove_from_list_article",
                event_label: "_" + customerId,
              });
            } else if (typeof ga !== "undefined") {
              ga(
                "send",
                "event",
                "remove_from_list_article",
                "_" + resourceId,
                "_" + customerId
              );
            }
            // GTMイベント (GA4)
            window.dataLayer = window.dataLayer || [];
            dataLayer.push({
              event: "remove_from_list_article",
              member_id: "_" + customerId,
              article_id: "_" + resourceId,
            });
          } else {
            // GAイベント
            if (typeof gtag !== "undefined") {
              gtag("event", "_" + resourceId, {
                event_category: "remove_from_list",
                event_label: "_" + customerId,
              });
            } else if (typeof ga !== "undefined") {
              ga(
                "send",
                "event",
                "remove_from_list",
                "_" + resourceId,
                "_" + customerId
              );
              // GTMイベント (GA4)
              window.dataLayer = window.dataLayer || [];
              dataLayer.push({
                event: "remove_from_list",
                member_id: "_" + customerId,
                product_id: "_" + resourceId,
              });
            }
          }
        } else {
          // ADD TO LIST
          wishlist.data("wished", true).addClass("wished");
          const payload = { blog_id: wishlist.attr("blog-id") };
          const res = await FRACTA_WISHLIST.post(
            customerId,
            resourceId,
            wishlistType,
            payload
          );
          // console.log("wished", res);

          // GAに送信
          if (wishlistType == "articles") {
            // GAイベント
            if (typeof gtag !== "undefined") {
              gtag("event", "_" + resourceId, {
                event_category: "add_to_list_article",
                event_label: "_" + customerId,
              });
            } else if (typeof ga !== "undefined") {
              ga(
                "send",
                "event",
                "add_to_list_article",
                "_" + resourceId,
                "_" + customerId
              );
            }
            // GTMイベント (GA4)
            window.dataLayer = window.dataLayer || [];
            dataLayer.push({
              event: "add_to_list_article",
              member_id: "_" + customerId,
              article_id: "_" + resourceId,
            });
          } else {
            // GAイベント
            if (typeof gtag !== "undefined") {
              gtag("event", "_" + resourceId, {
                event_category: "add_to_list",
                event_label: "_" + customerId,
              });
            } else if (typeof ga !== "undefined") {
              ga(
                "send",
                "event",
                "add_to_list",
                "_" + resourceId,
                "_" + customerId
              );
            }
            // GTMイベント
            window.dataLayer = window.dataLayer || [];
            dataLayer.push({
              event: "add_to_list",
              member_id: "_" + customerId,
              product_id: "_" + resourceId,
            });
          }
        }
      });
    });
  },
  emptyItem: (item) =>
    !Object.keys(item.shopify_object).length ||
    !item.shopify_object.published_at,
  sort: (a, b) => (a.created_at > b.created_at ? -1 : 0),
  arrangeWishlistPage: async (customerId) => {
    const filterShopifyObject = (item) =>
      !FRACTA_WISHLIST_FRONTEND.emptyItem(item);
    const res = await FRACTA_WISHLIST.list(customerId);
    const wishedItems = res.Items;
    wishedItems
      .filter(filterShopifyObject)
      .sort(FRACTA_WISHLIST_FRONTEND.sort)
      .forEach((item) => {
        // console.log(item);
        const template = $(
          $(`#fracta-wishlist-card-template-${item.type}`).html()
        );
        template
          .find("[wishlist-object-remove-icon]")
          .data("item", item)
          .click(async function () {
            const item = $(this).data("item");
            await FRACTA_WISHLIST.delete(
              item.customer_id,
              item.object_id,
              item.type
            );
            // 一覧から削除する
            $(this).parents(".fracta-wish-list-object").remove();
            FRACTA_WISHLIST_FRONTEND.displayWishedItemsNotFoundMessage();

            // GAに送信
            if (item.type == "articles") {
              // GAイベント
              if (typeof gtag !== "undefined") {
                gtag("event", "_" + item.object_id, {
                  event_category: "remove_from_list_article",
                  event_label: "_" + item.customer_id,
                });
              } else if (typeof ga !== "undefined") {
                ga(
                  "send",
                  "event",
                  "remove_from_list_article",
                  "_" + item.object_id,
                  "_" + item.customer_id
                );
              }
              // GTMイベント (GA4)
              window.dataLayer = window.dataLayer || [];
              dataLayer.push({
                event: "remove_from_list_article",
                member_id: "_" + item.customer_id,
                article_id: "_" + item.object_id,
              });
            } else {
              // GAイベント
              if (typeof gtag !== "undefined") {
                gtag("event", "_" + item.object_id, {
                  event_category: "remove_from_list",
                  event_label: "_" + item.customer_id,
                });
              } else if (typeof ga !== "undefined") {
                ga(
                  "send",
                  "event",
                  "remove_from_list",
                  "_" + item.object_id,
                  "_" + item.customer_id
                );
              }
              // GTMイベント (GA4)
              window.dataLayer = window.dataLayer || [];
              dataLayer.push({
                event: "remove_from_list",
                member_id: "_" + item.customer_id,
                product_id: "_" + item.object_id,
              });
            }

            return false;
          });
        template.find("[wishlist-object-attr]").each(function () {
          const attr = $(this).attr("wishlist-object-attr");
          const value = FRACTA_WISHLIST_FRONTEND.getVal(
            attr,
            item.shopify_object
          );
          //console.log(attr+" : "+value)
          //console.log(location.pathname )

          switch (attr) {
            case "handle":
              $(this).prop("href", FRACTA_WISHLIST_FRONTEND.getHandleURL(item));
              break;
            case "image.src":
              if (value) {
                // URLからファイル名を取り出す
                // https://qiita.com/kerupani129/items/adc0fba4ab248330e443
                const url = value;
                const matchedFileName =
                  url.match(
                    /^(?:[^:\/?#]+:)?(?:\/\/[^\/?#]*)?(?:([^?#]*\/)([^\/?#]*))?(\?[^#]*)?(?:#.*)?$/
                  ) ?? [];
                const [, dir, fileName, query] = matchedFileName.map(
                  (match) => match ?? ""
                );
                const matchedExt = fileName.match(/^(.+?)(\.[^.]+)?$/) ?? [];
                const [, name, ext] = matchedExt.map((match) => match ?? "");
                // console.log(name, ext);
                // 画像のサイズを小さいものにする
                const image = value.split(name).join(name + "_medium");
                $(this).css({ backgroundImage: `url(${image})` });
              }
              break;
            case "title":
              this.page = location.pathname;
              this.lang = document.querySelector("html").getAttribute("lang");

              let queryMeta;

              if (this.page == "/pages/saved-artists") {
                $(this).text(value);
              } else if (
                this.page ==
                "/" + this.lang.toLowerCase() + "/pages/saved-artists"
              ) {
                $(this).text(value);
              } else {
                if (this.lang == "ja") {
                  queryMeta = `artworkNameLocalized: metafield(namespace: "my_fields", key: "_title_japan") {value}`;
                } else if (this.lang == "zh-CN") {
                  queryMeta = `artworkNameLocalized: metafield(namespace: "my_fields", key: "_title_zh-cn") {value}`;
                } else if (this.lang == "zh-TW") {
                  queryMeta = ` artworkNameLocalized: metafield(namespace: "my_fields", key: "_title_zh-tw") {value}`;
                } else if (this.lang == "ko") {
                  queryMeta = ` artworkNameLocalized: metafield(namespace: "my_fields", key: "_title_ko") {value}`;
                } else {
                }
              }
              let ids = [];
              ids.push("id:" + item.object_id);
              let idsQuery = ids.join(" OR ");

              const url =
                "https://whitestone-dev.myshopify.com/api/2021-10/graphql.json";
              const accessToken = "9a1a788f6709aad4bb9de32bcc8fa528";
              let query;

              if (this.lang == "en") {
                query =
                  `{
                                  products(first:` +
                  ids.length +
                  `, query:"` +
                  idsQuery +
                  `") {
                                      edges {
                                          node {
                                                    id
                                                    title
                                                    }
                                                  }
                                  }
                                }`;
              } else {
                query =
                  `{
                                  products(first:` +
                  ids.length +
                  `, query:"` +
                  idsQuery +
                  `") {
                                      edges {
                                          node {
                                                    id
                                                    title
                                                    ` +
                  queryMeta +
                  `
                                                    }
                                                  }
                                  }
                                }`;
              }

              console.log(query);
              const options = {
                method: "post",
                headers: {
                  "Content-Type": "application/json",
                  "X-Shopify-Storefront-Access-Token": accessToken,
                },
                body: JSON.stringify({ query: query }),
              };

              fetch(url, options)
                .then((result) => result.json())
                .then(({ data }) => {
                  const { products = {} } = data;
                  const { edges = [] } = products;
                  edges.forEach((edge) => {
                    let product = edge.node;
                    if (this.lang == "en") {
                      $(this).text(value);
                    } else {
                      $(this).text(product.artworkNameLocalized.value);
                    }
                  });
                });
              break;
            case "vendor":
              this.lang = document.querySelector("html").getAttribute("lang");
              let queryMeta2;
              if (this.lang == "ja") {
                queryMeta2 = `artistNameLocalized: metafield(namespace: "my_fields", key: "_artist_ja") {value}`;
              } else if (this.lang == "zh-CN") {
                queryMeta2 = `artistNameLocalized: metafield(namespace: "my_fields", key: "_artist_zh-cn") {value}`;
              } else if (this.lang == "zh-TW") {
                queryMeta2 = ` artistNameLocalized: metafield(namespace: "my_fields", key: "_artist_zh-tw") {value}`;
              } else if (this.lang == "ko") {
                queryMeta2 = ` artistNameLocalized: metafield(namespace: "my_fields", key: "_artist_ko") {value}`;
              } else {
              }

              let ids2 = [];
              ids2.push("id:" + item.object_id);
              let idsQuery2 = ids2.join(" OR ");

              const url2 =
                "https://whitestone-dev.myshopify.com/api/2021-10/graphql.json";
              const accessToken2 = "9a1a788f6709aad4bb9de32bcc8fa528";
              let query2;

              if (this.lang == "en") {
                query2 =
                  `{
								products(first:` +
                  ids2.length +
                  `, query:"` +
                  idsQuery2 +
                  `") {
                                	edges {
                                    	node {
                                                  id
                                                  title
                                                  }
                                                }
                                }
						      }`;
              } else {
                query2 =
                  `{
								products(first:` +
                  ids2.length +
                  `, query:"` +
                  idsQuery2 +
                  `") {
                                	edges {
                                    	node {
                                                  id
                                                  title
                                                  ` +
                  queryMeta2 +
                  `
                                                  }
                                                }
                                }
						      }`;
              }

              const options2 = {
                method: "post",
                headers: {
                  "Content-Type": "application/json",
                  "X-Shopify-Storefront-Access-Token": accessToken2,
                },
                body: JSON.stringify({ query: query2 }),
              };

              fetch(url2, options2)
                .then((result) => result.json())
                .then(({ data }) => {
                  const { products = {} } = data;
                  const { edges = [] } = products;
                  edges.forEach((edge) => {
                    let product = edge.node;
                    if (this.lang == "en") {
                      $(this).text(value);
                    } else {
                      $(this).text(product.artistNameLocalized.value);
                    }
                  });
                });
              break;
            case "variants[0].price":
              if (parseFloat(value) > 0) {
                $(this).text(FRACTA_WISHLIST_FRONTEND.convertPrice(value));
              } else {
                $(this).text("Sold");
              }
              break;
            default:
              $(this).text(value || "");
          }
        });

        $(`#fracta-wishlist-grid-${item.type}`).append(template);
      });

    FRACTA_WISHLIST_FRONTEND.displayWishedItemsNotFoundMessage();
    $("#fracta-wishlist-loading").hide();
    $("#fracta-wishlist-grid").fadeIn("slow");

    // delete unavailable items
    wishedItems.filter(FRACTA_WISHLIST_FRONTEND.emptyItem).forEach((item) => {
      FRACTA_WISHLIST.delete(item.customer_id, item.object_id, item.type);
    });
  },

  init: async (event) => {
    // console.log(`jQuery version ${$().jquery}`);
    // console.log("Fracta wishlist custom application load.");
    const customerId = $("body").attr("data-customer-id");
    if (!customerId) {
      // 非ログイン時は何もボタン非表示。旧使用ボタンがログに促しポップアップのトリガーとして表示される
      // console.log("Customer not Login. Do nothing.");
      return;
    }
    // handle add item and remove item
    const wishlistContainers = $(".fracta-wishlist-container");
    const fractaWishlistPage = $("#fracta-wishlist-page");
    if (fractaWishlistPage.is(":visible")) {
      await FRACTA_WISHLIST_FRONTEND.arrangeWishlistPage(customerId);
    } else if (wishlistContainers.length > 0) {
      await FRACTA_WISHLIST_FRONTEND.wishHandler(
        wishlistContainers,
        customerId
      );
    } else {
      // console.log("Not target page.");
    }
  },

  convertPrice: (price) => {
    var s = String(price).split(".");
    var result = String(s[0]).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
    // if (s.length > 1) {
    //   result += '.' + s[1];
    // }
    return "$" + result;
  },
};

window.addEventListener("DOMContentLoaded", (event) => {
  if (!window.jQuery) {
    const scriptSource = "https://code.jquery.com/jquery-2.2.4.min.js";
    var script = document.createElement("script");
    script.type = "text/javascript";
    script.src = scriptSource;
    document.getElementsByTagName("head")[0].appendChild(script);
  }
  // console.log("jQuery loaded and parsed");

  jQuery(function () {
    FRACTA_WISHLIST_FRONTEND.init();
  });
});
